import React from 'react';

import { createClassName } from 'utils/createClassName';

import './textStyles.scss';

type Size = 's' | 'm' | 'mp' | 'mpp' | 'mppp' | 'l';

type Theme =
  | 'c1'
  | 'c2'
  | 'p1'
  | 'p2'
  | 'p3'
  | 's1'
  | 's2'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5';

type Props = {
  color?:
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'critical'
    | 'successful'
    | 'inherit';
  size?: Size;
  theme?: Theme;
  weight?: 'regular' | 'medium' | 'bold';
  family?: 'roboto' | 'futura';
  animatedColor?: boolean;
  upperCase?: boolean;
  underline?: boolean;
  breakAll?: boolean;
};

export const TextComponent: React.FC<Props> = (props) => {
  const {
    children,
    theme,
    color = 'primary',
    size = 'm',
    weight = 'regular',
    family = 'roboto',
    animatedColor,
    upperCase,
    underline,
    breakAll,
  } = props;

  const className = createClassName('text')({
    theme,
    color,
    size,
    weight,
    animatedColor,
    upperCase,
    family,
    underline,
    breakAll,
  });

  return <span className={className}>{children}</span>;
};
